<template>
  <div>
    <div class="card top-draft">
      <div class="card-body">
        <div class="col-lg-12 mg-top-1">
          <b-button variant="primary" @click="toCreate()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div>

        <div class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.contentKeyword"
              placeholder="请输入搜索内容"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="getList()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" class="w-300">门店名称</th>
                  <th scope="col">门店地址</th>
                  <th scope="col">创建日期</th>
                  <th scope="col"><span class="px-2">操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.name }}</td>
                  <td>{{ item.address || "--" }}</td>
                  <td>{{ item.createdAt || "--" }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                    >
                      编辑
                    </button>
                    <button
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="remove(item)"
                    >
                      移除
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination ref="page" @pageCallback="pageCallback"></pagination>

          <detail @getList="getList" :tagList="tagList" ref="detail"></detail>
        </div>
      </div>
    </div>
    <app-list-loading ref="loading"></app-list-loading>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import detail from "./detail";
import pagination from "@/components/pagination/pagination.vue";
import shop from "../../../server/api/shop";

/**
 * Contacts-list component
 */
export default {
  components: {
    pagination,
    detail,
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        contentKeyword: "",
      },
      items: [],
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    this.getList();
  },

  created() {},

  methods: {
    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams);
      this.$refs.loading.show();
      this.items = [];
      shop.list(params).then((resp) => {
        if (resp.data) {
          if (this.$refs.loading) {
            this.$refs.loading.hide(resp.data.items);
          }

          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //添加
    toCreate() {
      this.$refs.detail.showModel();
    },

    //去编辑
    toDetail(item) {
      this.$refs.detail.showModel(item.id);
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.id = item.id;
          shop.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
